import axios from 'axios';

const http = axios.create({
  timeout: 5000,
});

export default {
  async getTicketCheck(user, ticketId, config) {
    let headers;
    const type = user.userType ?? user.type;
    if (type === 'ANONYMOUS') {
      headers = {
        Authorization: `Basic ${btoa(`${user.uuid}:${user.auth.password}`)}`,
        'SEVEN-LOCALE': config.locale,
      };
    } else {
      const token = user.token ?? user.auth.token;
      if (token) {
        headers = {
          Authorization: `Bearer ${token}`,
          'http-x-nab-betshop-id': config.betshop.id,
          'http-x-nab-company-id': config.companyData.id,
          'http-x-nab-device-uuid': config.device.uuid,
          'http-x-nab-dp': 'AdminTerminal',
          'seven-locale': config.locale,
          'x-nsft-seven-company-uuid': config.companyData.uuid,
        };
      }
    }
    const url =
      type === 'ANONYMOUS'
        ? process.env.VUE_APP_TERMINAL_TICKET_CHECK_API
        : process.env.VUE_APP_TERMINAL_ADMIN_TICKET_CHECK_PATH;

    const response = await http.get(`${url}/${ticketId}.json`, {
      headers,
    });

    return response.data;
  },
  async checkTicketByProviderBetslipId(providerBetslipId, config, user) {
    const baseURL = process.env.VUE_APP_NGS_API;
    const ticketCheckPath = this.interpolateUrl(
      process.env.VUE_APP_NEXTGEN_WEB_TICKET_CHECK_PATH,
      {
        requestUuid: providerBetslipId,
      },
    );

    return http.get(`${baseURL}${ticketCheckPath}`, {
      params: {
        product: 'Keno',
      },
      headers: {
        Authorization: `Bearer ${user.auth.token}`,
        'X-Nsft-Ngs-Company': config.tenantId,
        'X-Nsft-Ngs-Product': config.productId,
      },
    });
  },
  // USED TO POPULATE VALUES INSIDE {} curly brackets in url
  interpolateUrl(url, config) {
    return url.replace(/{([^}]+)}/g, (match, key) =>
      Object.prototype.hasOwnProperty.call(config, key) ? config[key] : match,
    );
  },
};
